const i18n = require('swa-locale/i18n');
const Link = require('swa-components-core/link');
const PropTypes = require('prop-types');
const React = require('react');
const urls = require('swa-bootstrap-data/urls');

class CorporateLandingHomePageDashboardLight extends React.Component {
    static propTypes = {
        dashboardName: PropTypes.string
    };

    render() {
        return (
            <div className="dashboard dashboard-light"></div>
        );
    }
}

module.exports = CorporateLandingHomePageDashboardLight;
